<template>
  <v-col cols="12" md="6">
    <v-dialog v-model="modal" persistent width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="BookingTime"
          label="Drop-off Time"
          :prepend-icon="icon"
          readonly
          v-on="on"
        ></v-text-field>
      </template>
      <v-time-picker v-if="modal" v-model="BookingTime" ampm-in-title>
        <div class="flex-grow-1"></div>
        <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
        <v-btn text color="primary" @click="updateTime(BookingTime)">OK</v-btn>
      </v-time-picker>
    </v-dialog>
  </v-col>
</template>

<script>
import { mdiClockOutline } from "@mdi/js";
export default {
  data: () => ({
    modal: false,
    icon: mdiClockOutline,
    BookingTime: "10:00"
  }),
  methods: {
    updateTime: function(updatedTime) {
      if (updatedTime != null) {
        this.BookingTime = updatedTime;
        this.modal = false;
      }
    }
  },
  watch: {
    BookingTime: {
      immediate: true,
      handler(val) {
        this.$emit("change", "BookingTime", val);
      }
    }
  }
};
</script>